export default function ImageLoader({ src }) {
  return `https://kaiwa.azurewebsites.net${src}`;
}
